import React, { Component } from 'react';
import Page from '../pages/Page';
import DashboardContainer from '../containers/Dashboard';
import { injectIntl } from 'react-intl';
import SupportWidget from './SupportWidget';
class Dashboard extends Component {
  getMetaData() {
    return {
      title: this.pageTitle(),
      meta: this.pageMeta(),
      link: this.pageLink()
    };
  }

  pageTitle = () => {
    return this.props.intl.formatMessage({id: 'dashboard.pageTitle'});
  };

  pageMeta = () => {
    return [
      { name: 'description', content: this.props.intl.formatMessage({id: 'dashboard.pageDescription'}) }
    ];
  };

  pageLink = () => {
    return [];
  };

  componentDidMount () {
    SupportWidget();
  }

  render() {
    return (
      <Page {...this.getMetaData()}>
        <DashboardContainer {...this.props} />
      </Page>
    );
  }
}

export default injectIntl(Dashboard);




// WEBPACK FOOTER //
// app/pages/Dashboard.jsx